import { TradeStatusEnum, type CustomerTrade } from '@talos/kyoko';

export function isTradeCancelled(trade: CustomerTrade) {
  return trade.TradeStatus === TradeStatusEnum.Canceled;
}
